import React, { useState, useEffect } from "react";
import "react-lazy-load-image-component/src/effects/blur.css"; // blur effect
import "./CSS/NewNav.css";
import logo from "../Images/logodarvik.png";
import Logo from "../Components/logo.jsx";
const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMenuOpen(false); // Close menu when switching to desktop view
      }
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <header className={`main-header ${scrolled ? "scrolled" : ""}`}>
      <div className="container">
        {/* Top Bar - hide on mobile */}
        {!isMobile && !scrolled && (
          <nav className="navigation-top">
            <div className="navigation-top-left">
              <a href="https://facebook.com" aria-label="Facebook">
                <i className="bi bi-facebook social-icon"></i>
              </a>
              <a href="https://twitter.com" aria-label="Twitter">
                <i className="bi bi-twitter social-icon"></i>
              </a>
              <a
                href="https://youtube.com/@darvikfoundation?si=uOKhw_eJteQtLyyk"
                aria-label="YouTube"
              >
                <i className="bi bi-youtube social-icon"></i>
              </a>
            </div>
            <div className="navigation-top-right">
              <a href="/donate">
                <i className="fas fa-hand-holding-heart me-2"></i> Donate
              </a>
              <a href="tel:+919946613508">
                <i className="bi bi-telephone-fill me-2"></i> +91 99466 13508
              </a>
            </div>
          </nav>
        )}

        <nav className="navigation-main">
          {isMobile ? (
            <>
              {/* Logo on left */}
              <div className="logo-wrapper mobile">
                <Logo
                  hdLogo={logo} 
                  lowResLogo="https://res.cloudinary.com/dgxhp09em/image/upload/v1755689357/apple-touch-icon_nozp8r.png"  // Put your low-res logo URL here
                />
              </div>


              {/* Hamburger on right */}
              <div
                className="hamburger"
                onClick={() => setIsMenuOpen((open) => !open)}
                aria-label="Toggle menu"
                aria-expanded={isMenuOpen}
                tabIndex={0}
                role="button"
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setIsMenuOpen((open) => !open);
                  }
                }}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </>
          ) : (
            <>
              <ul className="navigation-left">
                <li><a href="/">HOME</a></li>
                <li><a href="/about">ABOUT US</a></li>
                <li><a href="/news">NEWS</a></li>
                <li><a href="/gallery">GALLERY</a></li>
              </ul>

              <div className={`logo-wrapper ${scrolled ? "small" : ""}`}>
                <div className={`logo-wrapper ${scrolled ? "small" : ""}`}>
                  <Logo
                    hdLogo={logo}  // HD logo
                    lowResLogo="https://res.cloudinary.com/dgxhp09em/image/upload/v1755689357/apple-touch-icon_nozp8r.png"
                  />
                </div>

              </div>

              <ul className="navigation-right">
                <li><a href="/services">SERVICES</a></li>
                <li><a href="/team">TEAM</a></li>
                <li><a href="/testimonials">TESTIMONIALS</a></li>
                <li><a href="/contact">CONTACT US</a></li>
              </ul>
            </>
          )}
        </nav>

        {/* Mobile Menu Dropdown */}
        {isMobile && isMenuOpen && (
          <div
            className="mobile-menu"
            role="menu"
            aria-label="Mobile Navigation Menu"
          >
            <a href="/" onClick={() => setIsMenuOpen(false)}>HOME</a>
            <hr className="menu-separator" />
            <a href="/about" onClick={() => setIsMenuOpen(false)}>ABOUT US</a>
            <hr className="menu-separator" />
            <a href="/news" onClick={() => setIsMenuOpen(false)}>NEWS</a>
            <hr className="menu-separator" />
            <a href="/gallery" onClick={() => setIsMenuOpen(false)}>GALLERY</a>
            <hr className="menu-separator" />
            <a href="/services" onClick={() => setIsMenuOpen(false)}>SERVICES</a>
            <hr className="menu-separator" />
            <a href="/team" onClick={() => setIsMenuOpen(false)}>TEAM</a>
            <hr className="menu-separator" />
            <a href="/testimonials" onClick={() => setIsMenuOpen(false)}>TESTIMONIALS</a>
            <hr className="menu-separator" />
            <a href="/contact" onClick={() => setIsMenuOpen(false)}>CONTACT US</a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Nav;
